import React, { useContext, useMemo } from "react";

import "./EUMRVVoyages.scss";

import CustomTable from "../../../../../../common/customTable/CustomTable";
import {
	EUMRV_VOYAGES_HEADERS,
	EuVoyagesDerogationOMRColumns,
} from "../../../../../../constants/CustomTableHeaders";
import { ClaimsContext } from "../../../../../../services/ClaimsService";
import { FeatureType } from "../../../../../../constants/FeatureToggles";

const EuVoyagesDerogationOMR = ({ data }) => {
	//feature toggle for blend fuel registry
	const mrvAccessorKeys = [
		"co2Mrv",
		"ch4Mrv",
		"n2oMrv",
		"co2EqMrv",
	];
	const dynamicColumns = useMemo(() => {

			return EuVoyagesDerogationOMRColumns?.filter(
			  col => !mrvAccessorKeys.includes(col.accessorKey)
			);

	}, [EuVoyagesDerogationOMRColumns]);

	return (
		<div className="EUMRV-custom-table-container mt-3 eu_mrv_voyage">
			<CustomTable
				columnsData={dynamicColumns}
				renderTableData={data || []}
				customProps={{
					header: EUMRV_VOYAGES_HEADERS.OMR,
					enableSort: false,
					tableName: "emissions-report",
					maxHeight: "30vh",
				}}
			/>
		</div>
	);
};

export default EuVoyagesDerogationOMR;
